import './General.css'
import './Home.css'
import React, { Component } from 'react'
import { Button, Col, Image, ProgressBar, Row, Tab, Tabs } from 'react-bootstrap'
import { IconContext } from "react-icons";
import { BsCircleFill, BsArrowUpRight } from 'react-icons/bs'

const blue = 'linear-gradient(180deg, rgba(40, 50, 145, 0.95) 40%, rgba(15, 15, 15, 0.85) 100%)'
const violet = 'linear-gradient(180deg, rgba(151, 62, 217, 0.95) 40%, rgba(15, 15, 15, 0.85) 100%)'
const red = 'linear-gradient(180deg, rgba(205, 63, 28, 0.95) 40%, rgba(15, 15, 15, 0.85) 100%)'
const green = 'linear-gradient(180deg, rgba(20, 116, 25, 0.95) 40%, rgba(15, 15, 15, 0.85) 100%)'

class Home extends Component {
    constructor(props) {
        super(props);

        let date = new Date();
        let year = date.getFullYear();
        this.state = {
            age: year - 1991,
            homeBgColor: blue
        }
    }

    generateSkills() {
        var skills = {
            'AWS': 2,
            'AWS CDK': 3,
            'Python': 3,
            'C#': 3,
            'JavaScript': 2,
            'React': 2,
            'SQL': 2,
            'Git': 4,
            'Subversion': 3,
            'Perforce': 2
        }
        var html = [];
        for (const [key, value] of Object.entries(skills)) {
            var circles = undefined;
            switch (value) {
                case 1:
                    circles = <Col><BsCircleFill/><BsCircleFill style={{color: 'white'}}/><BsCircleFill style={{color: 'white'}}/><BsCircleFill style={{color: 'white'}}/><BsCircleFill style={{color: 'white'}}/><span className='home-text'> Novice</span></Col>
                    break;
                case 2:
                    circles = <Col><BsCircleFill/><BsCircleFill/><BsCircleFill style={{color: 'white'}}/><BsCircleFill style={{color: 'white'}}/><BsCircleFill style={{color: 'white'}}/><span className='home-text'> Intermediate</span></Col>
                    break;
                case 3:
                    circles = <Col><BsCircleFill/><BsCircleFill/><BsCircleFill/><BsCircleFill style={{color: 'white'}}/><BsCircleFill style={{color: 'white'}}/><span className='home-text'> Proficient</span></Col>
                    break;
                case 4:
                    circles = <Col><BsCircleFill/><BsCircleFill/><BsCircleFill/><BsCircleFill/><BsCircleFill style={{color: 'white'}}/><span className='home-text'> Advanced</span></Col>
                    break;
                case 5:
                    circles = <Col><BsCircleFill/><BsCircleFill/><BsCircleFill/><BsCircleFill/><BsCircleFill/><span className='home-text'> Expert</span></Col>
                    break;
                default:
                    circles = <Col><BsCircleFill/><BsCircleFill style={{color: 'white'}}/><BsCircleFill style={{color: 'white'}}/><BsCircleFill style={{color: 'white'}}/><BsCircleFill style={{color: 'white'}}/><span className='home-text'> Novice</span></Col>
            }
            html.push(
                <Row className='home-row-skills'>
                    <Col xs={4}>
                        <p className='home-text'>{key}</p>
                    </Col>
                    {circles}
                </Row>
            )
        }
        return html;
    }

    changeColor(color) {
        this.setState({
            homeBgColor: color
        });
    }

    render() {
        return (
            <div id='home' className='container-fluid general-container home-container'>
                <div className='general-jumbotron'>
                    <Row>
                        <Button className='home-btn-whats-new' href="https://jonathanferreira.com/echoes-from-the-void/2024-05-17" target='_blank' rel='noreferrer noopener'><BsArrowUpRight/> NEW BLOG POST: "Thoughts On Yakuza 5" 2024-05-17</Button>
                    </Row>
                    <Row>
                        <Col sm={4} lg={2} className='home-col-bg' style={{background: `${this.state.homeBgColor}`}}>
                            <Image className='general-image image rounded-circle home-photo' src="/images/profile.jpg" alt='The site developer' fluid />
                        </Col>
                        <Col className='home-col-bg' style={{background: `${this.state.homeBgColor}`}}>
                            <div className='home-header'>Jonathan Ferreira</div>
                            <div className='home-subtitle'>Lead Software Developer</div>
                            <div className='home-subtitle'>Age: {this.state.age}</div> 
                        </Col>
                        <Col sm={4} lg={2} className='home-col-colors' style={{background: `${this.state.homeBgColor}`}}>
                            <div className='home-window-color-text'>Window color</div>
                            <hr className="solid home-divider"/>
                            <Row>
                                <Button className='rounded-circle home-color-btn' onClick={() => this.changeColor(blue)} style={{background: `${blue}`}}></Button>
                                <Button className='rounded-circle home-color-btn' onClick={() => this.changeColor(violet)} style={{background: `${violet}`}}></Button>
                                <Button className='rounded-circle home-color-btn' onClick={() => this.changeColor(red)} style={{background: `${red}`}}></Button>
                                <Button className='rounded-circle home-color-btn' onClick={() => this.changeColor(green)} style={{background: `${green}`}}></Button>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='home-col-bg' style={{background: `${this.state.homeBgColor}`}}>
                            <div className='home-small-header'>Skills</div>
                            <hr className="solid home-divider"/>
                            <div className='home-skills-scrollbar'>
                                <IconContext.Provider value={{ className: 'home-skills-bubble', size: '20px' }}>
                                    {this.generateSkills()}
                                </IconContext.Provider>
                            </div>
                        </Col>
                        <Col className='home-col-bg' style={{background: `${this.state.homeBgColor}`}}>
                            <div className='home-small-header'>Languages</div>
                            <hr className="solid home-divider"/>
                            <div className='home-small-header'></div>
                            <Row className='home-row-flat home-progress'>
                                <p className='home-text'>English (Native Fluent)</p>
                                <ProgressBar className='home-progress-bar' now={100} />
                            </Row>
                            <Row className='home-row-flat'>
                                <p className='home-text'>Portuguese (Intermediate)</p>
                                <ProgressBar className='home-progress-bar' now={20} />
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='home-col-bg' style={{background: `${this.state.homeBgColor}`}}>
                            <div className='home-small-header'>Experience</div>
                            <hr className="solid home-divider"/>
                            <Tabs defaultActiveKey='paramount-global' id='tab-jobs' className='mb-3' justify>
                                <Tab tabClassName='home-tab-inner' eventKey='paramount-global' title='Paramount Global'>
                                    <Row className='home-row-flat'>
                                        <p className='home-small-header'>Lead Software Developer (December 2022 - Present)</p>
                                    </Row>
                                    <Row>
                                        <ul>
                                            <li className='home-text'>Orchestrated migration of build system from Jenkins to AWS CodePipeline.</li>
                                            <li className='home-text'>Co-developed a UI using AWS Amplify and React for a distributed cloud system.</li>
                                            <li className='home-text'>Provided AWS cloud support to developers.</li>
                                            <li className='home-text'>Reviewed code from junior developers and provided guidance for new system designs.</li>
                                            <li className='home-text'>Contributed to team documentation efforts with an emphasis on diagrams for complex system designs.</li>
                                        </ul>
                                    </Row>
                                </Tab>
                                <Tab tabClassName='home-tab-inner' eventKey='bioware' title='BioWare'>
                                    <Row className='home-row-flat'>
                                        <p className='home-small-header'>Platform Engineer (July 2019 - November 2021)</p>
                                    </Row>
                                    <Row>
                                        <ul>
                                            <li className='home-text'>Developed for and maintained C# microservices and proprietary libraries for Anthem which handled player data, 
                                                scheduled content, in-game economy transactions, and more.
                                            </li>
                                            <li className='home-text'>Integrated EA central service APIs as part of initiatives to maintain similar technological solutions across studios.</li>
                                            <li className='home-text'>Wrote and maintained CloudFormation resource stacks using sceptre tooling wrapped by the troposphere Python library.</li>
                                            <li className='home-text'>Authored a distributed system written in Python and deployed to AWS Lambdas to serve and delete player data in 
                                                fulfillment of data privacy access requests. Modularized system to allow for other developers to develop standalone implementations 
                                                specific to legacy titles and deploy with CloudFormation templates.
                                            </li>
                                            <li className='home-text'>Translated legacy JavaScript launcher for Star Wars: Knights of the Old Republic into AngularJS app with a backend 
                                                powered by Solid State Networks Direct 6. Additionally wrote user flow test cases for QA.
                                            </li>
                                        </ul>
                                    </Row>
                                </Tab>
                                <Tab tabClassName='home-tab-inner' eventKey='viacom' title='Viacom'>
                                    <Row className='home-row-flat'>
                                        <p className='home-small-header'>Software Developer (May 2016 - May 2019)</p>
                                    </Row>
                                    <Row>
                                        <ul>
                                            <li className='home-text'>Co-developed an asset archive system integrated with the IBM TS3500 Tape Library for Paramount Pictures.</li>
                                            <li className='home-text'>Worked on an established code base for transcoding videos, adding new features and integrating new third party transcode software.</li>
                                            <li className='home-text'>Created a series of metric graphs using the D3 JavaScript library for a React website developed to automate video transformation rules.</li>
                                            <li className='home-text'>Redesigned a legacy system for automated video fingerprint file uploads to third party vendors.</li>
                                        </ul>
                                    </Row>
                                </Tab>
                                <Tab tabClassName='home-tab-inner' eventKey='dow-jones' title='Dow Jones'>
                                    <Row className='home-row-flat'>
                                        <p className='home-small-header'>Service Desk Analyst (November 2014 - May 2016)</p>
                                    </Row>
                                    <Row>
                                        <ul>
                                            <li className='home-text'>Provided installation and support for over 200 applications used by The Wall Street Journal, New York Post, Barron's, and MarketWatch.</li>
                                            <li className='home-text'>Troubleshot hardware and software failures on Windows and OSX.</li>
                                            <li className='home-text'>Created and supported documentation for the Service Desk.</li>
                                            <li className='home-text'>Issued and managed security software certificates (RSA, PKI) for system access.</li>
                                        </ul>
                                    </Row>
                                </Tab>
                            </Tabs>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

export default Home;
